export const FETCH_WALLET_HISTORY_FAILURE = 'LEDGER/FETCH_WALLET_HISTORY_FAILURE';
export const FETCH_WALLET_HISTORY_SUCCESS = 'LEDGER/FETCH_WALLET_HISTORY_SUCCESS';
export const FETCH_WALLET_HISTORY_REQUEST = 'LEDGER/FETCH_WALLET_HISTORY_REQUEST';